<template>
  <div class="ios-glass-page">
    <!-- 1. 背景光斑 -->
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
    </div>

    <!-- 2. 顶部工具栏 -->
    <div class="page-header">
      <div class="header-left">
        <span class="count" v-if="dataList.length">共{{dataList.length}}人</span>
      </div>
      <!-- 班级选择器 -->
      <div class="class-selector" @click="openClassPicker">
        <span class="label">{{ searchObj.classNameAll || '选择班级' }}</span>
        <van-icon name="arrow-down" size="12" />
      </div>
    </div>

    <!-- 3. 核心：冻结列毛玻璃表格 -->
    <div class="glass-table-wrapper" v-if="dataList.length > 0">
      <div class="table-scroll-container">
        <table class="custom-table" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <!-- 固定列表头 -->
              <th class="sticky-col left-col">
                <div class="cell">姓名</div>
              </th>
              <!-- 滚动列表头 -->
              <th><div class="cell">综合</div></th>
              <th><div class="cell">身高</div></th>
              <th><div class="cell">体重</div></th>
              <th><div class="cell">肺活量</div></th>
              <th><div class="cell">50米</div></th>
              <th><div class="cell">坐位体前屈</div></th>
              <th><div class="cell">立定跳远</div></th>
              <th><div class="cell">跳绳</div></th>
              <th><div class="cell">仰卧起坐</div></th>
              <th><div class="cell">50米x8</div></th>
              <th><div class="cell">800/1000米</div></th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="(item, index) in dataList" 
              :key="index"
              @click="handleRowClick(item)"
              class="data-row"
            >
              <!-- 固定列内容 -->
              <td class="sticky-col left-col">
                <div class="cell name-cell">
                  <span class="name">{{ item.studentName }}</span>
                </div>
              </td>
              <!-- 滚动列内容 -->
              <td>
                <div class="cell">
                  <span class="tag" :class="getLevelClass(item.weightLevel)">{{ item.weightLevel || '-' }}</span>
                </div>
              </td>
              <td><div class="cell">{{ item.Height || '-' }}</div></td>
              <td><div class="cell">{{ item.Weight || '-' }}</div></td>
              <td><div class="cell">{{ item.VitalCapacity || '-' }}</div></td>
              <td><div class="cell">{{ item.FiftyMeters || '-' }}</div></td>
              <td><div class="cell">{{ item.SitAndReach || '-' }}</div></td>
              <td><div class="cell">{{ item.Jump || '-' }}</div></td>
              <td><div class="cell">{{ item.RopeSkipping || '-' }}</div></td>
              <td><div class="cell">{{ item.SitUp || '-' }}</div></td>
              <td><div class="cell">{{ formatSeconds(item.RunBack) }}</div></td>
              <td><div class="cell">
                {{ formatSeconds(item.EigthHunderMeters || item.ThousandMeters) }}
              </div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-else class="empty-state">
      <div class="glass-card">
        <van-icon name="chart-trending-o" size="48" color="rgba(0,0,0,0.2)" />
        <p>请选择班级以加载成绩表</p>
      </div>
    </div>

    <!-- 4. 底部操作面板 (点击行触发) -->
    <van-action-sheet v-model="showActionSheet" :title="currentRow.studentName + ' 的操作'">
      <div class="action-content">
        <div class="action-grid">
           <div class="action-item" @click="onSeeReport(currentRow)">
             <div class="icon-box blue"><van-icon name="chart-trending-o" /></div>
             <span>体测报告</span>
           </div>
           <div class="action-item" @click="onbodyReport(currentRow)">
             <div class="icon-box orange"><van-icon name="notes-o" /></div>
             <span>体锻报告</span>
           </div>
           <div class="action-item" @click="onbodyAnalyse(currentRow)">
             <div class="icon-box purple"><van-icon name="fire-o" /></div>
             <span>运动分析</span>
           </div>
        </div>
        <div class="student-info-mini">
           <span>学号: {{currentRow.snCode}}</span>
           <span>性别: {{currentRow.sex}}</span>
        </div>
      </div>
    </van-action-sheet>

    <!-- 5. 班级选择器 (年级快捷胶囊栏 + 班级滚轮) -->
    <van-popup v-model="classShowPicker" round position="bottom" class="glass-popup" @close="onCancelPicker">
       <div class="popup-header">
         <div class="btn cancel" @click="onCancelPicker">取消</div>
         <div class="title">选择班级</div>
         <div class="btn confirm" @click="onConfirmPicker">确定</div>
       </div>

       <!-- 年级快捷胶囊栏 -->
       <div v-if="gradeList && gradeList.length > 1" class="grade-capsule-bar">
         <div class="grade-scroll-wrap">
           <div 
             v-for="grade in gradeList" 
             :key="grade.code"
             class="grade-pill"
             :class="{ active: tempGrade === grade.code }"
             @click="handleGradePillClick(grade.code)"
           >
             <span class="grade-name">{{ grade.name }}</span>
             <span class="grade-count">({{ grade.count }})</span>
           </div>
         </div>
       </div>

       <van-picker 
         ref="classPicker" 
         :columns="filteredClassList" 
         :default-index="currentClassIndex" 
         :show-toolbar="false" 
         item-height="44" 
       />
    </van-popup>
  </div>
</template>

<script>
import { getClassInfoList, smallStudentScore } from "@/api/teacher/teacherScore.js";
import { setSession, getSession, removeSession } from "@/utils/cookie";

export default {
  name: 'StudentScoreTable',
  data() {
    return {
      allClassList: [],
      classShowPicker: false,
      showActionSheet: false,
      currentRow: {}, // 当前点击的学生
      tempGrade: 'ALL',
      searchObj: {
        classNameAll: '', 
        classCode: '',
        className: '',
        gradeCode: '',
        gradeName: '',
        selectedGrade: 'ALL'
      },
      dataList: [],
    };
  },
  computed: {
    gradeList() {
      if (!this.allClassList || this.allClassList.length === 0) return [];
      const map = new Map();
      this.allClassList.forEach(item => {
        const key = item.gradeKey;
        const name = item.gradeName || '未分年级';
        if (!map.has(key)) {
          map.set(key, { code: key, name: name, count: 0 });
        }
        map.get(key).count++;
      });
      return [
        { code: 'ALL', name: '全部年级', count: this.allClassList.length },
        ...Array.from(map.values())
      ];
    },
    filteredClassList() {
      if (!this.tempGrade || this.tempGrade === 'ALL') {
        return this.allClassList;
      }
      return this.allClassList.filter(item => item.gradeKey === this.tempGrade);
    },
    currentClassIndex() {
      if (!this.searchObj.classCode || !this.filteredClassList.length) return 0;
      let idx = this.filteredClassList.findIndex(item => 
        item.value === this.searchObj.classCode && 
        (!this.searchObj.className || item.className === this.searchObj.className || item.text === this.searchObj.className)
      );
      if (idx < 0) {
        idx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
      }
      return idx >= 0 ? idx : 0;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!to || !to.path || (to.path.indexOf('/fitnessReport') === -1 && to.path.indexOf('/bodyForging') === -1)) {
      removeSession('teacherReporting/teacherScore');
    }
    next();
  },
  created() {
    this.init();
    const cache = getSession('teacherReporting/teacherScore');
    if (cache) {
      try {
        const cachedObj = JSON.parse(cache);
        this.searchObj = Object.assign({}, this.searchObj, cachedObj);
      } catch (e) {}
      if (!this.searchObj.selectedGrade) {
        this.searchObj.selectedGrade = 'ALL';
      }
      if (this.searchObj.classCode) {
        this.getList();
      }
    }
  },
  methods: {
    // 样式辅助
    getLevelClass(level) {
      if (level === '优秀') return 'level-good';
      if (level === '良好') return 'level-fine';
      if (level === '及格') return 'level-pass';
      if (level === '不及格') return 'level-fail';
      return '';
    },
    formatSeconds(value) {
      if (!value) return '-';
      let second = parseInt(value);
      let minute = 0;
      if (second > 60) {
        minute = parseInt(second / 60);
        second = parseInt(second % 60);
      }
      return minute > 0 ? `${minute}′${second}″` : `${second}″`;
    },

    // 交互逻辑
    handleRowClick(item) {
      this.currentRow = item;
      this.showActionSheet = true;
    },

    // 路由跳转
    onSeeReport(item) { this.goRouter('/fitnessReport', item); },
    onbodyReport(item) { this.goRouter('/bodyForging', item); },
    onbodyAnalyse(item) {
      localStorage.removeItem('fitnessReport/chat_messages');
      this.goRouter('/fitnessReportV2', item);
    },
    goRouter(path, item) {
      let data = JSON.stringify({
        snCode: item.snCode, schoolCode: item.schoolCode, termCode: item.termCode,
        studentName: item.studentName, sex: item.sex, gradeName: item.gradeName,
        className: item.className, ...item, teacher: true
      });
      this.$router.push({ path: path, query: { data: data } });
      this.showActionSheet = false;
    },

    openClassPicker() {
      this.tempGrade = this.searchObj.selectedGrade || 'ALL';
      this.classShowPicker = true;
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
            this.$refs.classPicker.setColumnIndex(0, this.currentClassIndex);
          }
        });
      });
    },
    handleGradePillClick(gradeCode) {
      if (this.tempGrade === gradeCode) return;
      this.tempGrade = gradeCode;
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
            let targetIdx = 0;
            if (this.searchObj.classCode) {
              const foundIdx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
              if (foundIdx >= 0) {
                targetIdx = foundIdx;
              }
            }
            this.$refs.classPicker.setColumnIndex(0, targetIdx);
          }
        });
      });
    },
    onCancelPicker() {
      this.classShowPicker = false;
      this.tempGrade = this.searchObj.selectedGrade || 'ALL';
    },
    onConfirmPicker() {
      if (this.$refs.classPicker) {
        if (typeof this.$refs.classPicker.confirm === 'function') {
          this.$refs.classPicker.confirm();
        }
        let val = null;
        if (typeof this.$refs.classPicker.getValues === 'function') {
          const vals = this.$refs.classPicker.getValues();
          val = vals && vals[0];
        }
        if (!val && typeof this.$refs.classPicker.getColumnIndex === 'function') {
          const cIdx = this.$refs.classPicker.getColumnIndex(0);
          val = this.filteredClassList[cIdx];
        }
        if (!val && this.filteredClassList.length > 0) {
          val = this.filteredClassList[0];
        }
        if (val) {
          this.searchObj.selectedGrade = this.tempGrade || 'ALL';
          this.searchObj.classCode = val.value;
          this.searchObj.classNameAll = val.text;
          this.searchObj.className = val.className;
          this.searchObj.gradeCode = val.gradeCode;
          this.searchObj.gradeName = val.gradeName;
          this.getList();
          this.classShowPicker = false;
          setSession('teacherReporting/teacherScore', JSON.stringify(this.searchObj));
          return;
        }
      }
      this.classShowPicker = false;
    },
    init() {
      getClassInfoList({}).then(res => {
        const rawList = (res && res.data && res.data.data) || [];
        const seen = new Set();
        const uniqueList = [];
        rawList.forEach(item => {
          if (item && item.classCode) {
            const text = `${(item.gradeName || '').trim()} ${(item.className || '').trim()}`.trim() || item.className;
            const key = `${item.classCode}_${text}`;
            if (!seen.has(key)) {
              seen.add(key);
              uniqueList.push({
                text: text,
                className: item.className,
                value: item.classCode,
                gradeCode: item.gradeCode,
                gradeName: (item.gradeName || '').trim(),
                gradeKey: String(item.gradeCode || item.gradeName || 'other')
              });
            }
          }
        });
        this.allClassList = uniqueList;
      }).catch(() => {});
    },
    getList() {
      this.$toast.loading({ message: '加载数据...', forbidClick: true });
      smallStudentScore({
        classCode: this.searchObj.classCode,
        className: this.searchObj.className,
        grade: this.searchObj.gradeCode,
        gradeName: this.searchObj.gradeName,
        pageSize: 999,
        current: 1
      }).then(res => {
        res.data.body?.list?.forEach(el => {
          el?.scoreList.forEach(dl => el[dl.projectCode] = dl.score);
        });
        this.dataList = res.data.body.list || [];
        this.$toast.clear();
      }).catch(() => this.$toast.clear());
    }
  }
};
</script>

<style lang="less" scoped>
/* --- 基础环境 --- */
.ios-glass-page {
  min-height: 100vh;
  background: #f2f2f7;
  padding: 16px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif;
  color: #1c1c1e;
  position: relative;
  overflow: hidden;
}

/* 动态背景光斑 */
.background-blobs {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; pointer-events: none;
  .blob { position: absolute; border-radius: 50%; filter: blur(60px); opacity: 0.6; }
  .blob-1 { width: 300px; height: 300px; background: #e0f2ff; top: -50px; left: -50px; }
  .blob-2 { width: 250px; height: 250px; background: #ffece6; bottom: 50px; right: -50px; }
}

/* --- 顶部工具栏 --- */
.page-header {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 16px; position: relative; z-index: 1;

  .header-left {
    .title { font-size: 22px; font-weight: 700; margin: 0; color: #000; }
    .count { font-size: 13px; color: #8e8e93; }
  }

  /* 仿 iOS 胶囊按钮 */
  .class-selector {
    display: flex; align-items: center; gap: 6px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.6);
    padding: 8px 14px;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    transition: all 0.2s;

    &:active { transform: scale(0.96); background: rgba(255,255,255,0.9); }
    .label { font-size: 14px; font-weight: 600; color: #007AFF; }
    i { color: #007AFF; }
  }
}

/* --- 毛玻璃表格主体 --- */
.glass-table-wrapper {
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(30px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.table-scroll-container {
  overflow-x: auto;
  max-height: calc(100vh - 120px);
  -webkit-overflow-scrolling: touch;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: center;
  font-size: 13px;

  /* 表头 */
  th {
    background: rgba(245, 245, 247, 0.85);
    backdrop-filter: blur(10px);
    color: #8e8e93;
    font-weight: 600;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  /* 单元格 */
  td {
    padding: 14px 0;
    border-bottom: 1px solid rgba(0,0,0,0.03);
    color: #1c1c1e;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  .cell { padding: 0 12px; }

  /* 核心：姓名列首列冻结 */
  .sticky-col {
    position: sticky;
    left: 0;
    z-index: 1;
    /* 与背景同色系的微透半白，防止滚动内容穿透 */
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 4px 0 8px rgba(0,0,0,0.02); /* 侧面微投影区分 */
  }

  th.sticky-col {
    z-index: 3; /* 表头交叉点置于最顶层 */
    background: rgba(245, 245, 247, 0.98);
  }

  .name-cell {
    display: flex; align-items: center; gap: 8px; text-align: left;
    .avatar {
      width: 24px; height: 24px; border-radius: 50%; display: flex; 
      align-items: center; justify-content: center; font-size: 10px; color: #fff;
      &.boy { background: #007AFF; }
      &.girl { background: #FF2D55; }
    }
    .name { font-weight: 600; font-size: 14px; }
  }

  /* 行点击高亮反馈 */
  .data-row:active td {
    background: rgba(0, 122, 255, 0.05);
  }

  /* 标签胶囊化 */
  .tag {
    display: inline-block; padding: 2px 6px; border-radius: 6px; font-size: 11px; font-weight: 500;
    &.level-good { color: #34C759; background: rgba(52, 199, 89, 0.1); }
    &.level-fine { color: #007AFF; background: rgba(0, 122, 255, 0.1); }
    &.level-pass { color: #FF9500; background: rgba(255, 149, 0, 0.1); }
    &.level-fail { color: #FF3B30; background: rgba(255, 59, 48, 0.1); }
  }
}

/* --- ActionSheet 动作面板深度美化 --- */
.action-content {
  padding: 24px 20px 40px;
  .action-grid {
    display: flex; justify-content: space-around; margin-bottom: 20px;
    .action-item {
      display: flex; flex-direction: column; align-items: center; gap: 8px;
      .icon-box {
        width: 50px; height: 50px; border-radius: 16px; 
        display: flex; align-items: center; justify-content: center;
        font-size: 24px; color: #fff;
        &.blue { background: #007AFF; box-shadow: 0 4px 10px rgba(0,122,255,0.3); }
        &.orange { background: #FF9500; box-shadow: 0 4px 10px rgba(255,149,0,0.3); }
        &.purple { background: #5856D6; box-shadow: 0 4px 10px rgba(88,86,214,0.3); }
      }
      span { font-size: 12px; color: #666; }
    }
  }
  .student-info-mini {
    text-align: center; font-size: 12px; color: #999;
    span { margin: 0 6px; }
  }
}

/* --- 空状态 --- */
.empty-state {
  display: flex; justify-content: center; padding-top: 50px; z-index: 1;
  .glass-card {
    padding: 30px 50px; text-align: center;
    background: rgba(255,255,255,0.6); border-radius: 16px;
    p { margin-top: 10px; color: #999; font-size: 14px; }
  }
}

/* 底部弹窗 */
.glass-popup { background: #f2f2f7; }
.popup-header {
  display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background: #fff;
  .btn { font-size: 15px; cursor: pointer; }
  .cancel { color: #8e8e93; }
  .confirm { color: #007AFF; font-weight: 600; }
  .title { font-weight: 600; font-size: 16px; }
}

/* 年级快捷胶囊栏 */
.grade-capsule-bar {
  padding: 10px 16px 8px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  .grade-scroll-wrap {
    display: flex;
    overflow-x: auto;
    gap: 8px;
    padding-bottom: 2px;
    
    /* 隐藏滚动条 */
    &::-webkit-scrollbar { display: none; width: 0; height: 0; }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .grade-pill {
    flex-shrink: 0;
    padding: 6px 14px;
    border-radius: 16px;
    font-size: 13px;
    background: rgba(118, 118, 128, 0.08);
    color: #636366;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
    font-weight: 500;

    .grade-count {
      font-size: 11px;
      opacity: 0.75;
    }

    &.active {
      background: #007AFF;
      color: #fff;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);

      .grade-count {
        opacity: 0.9;
      }
    }

    &:active {
      transform: scale(0.96);
    }
  }
}
</style>
